<template>
  <Menu as="div" class="relative">
    <slot />
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems :class="menuItemsClass">
        <MenuItem v-slot="{ active }">
          <span
            @click="signout"
            :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer']"
          >
            {{ t("sign_out") }}
          </span>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Menu, MenuItem, MenuItems } from "@headlessui/vue";
import { mapActions } from "vuex";

export default {
  name: "UserMenu",
  components: { Menu, MenuItem, MenuItems },

  props: {
    menuItemsClass: {
      type: String,
      default:
        "z-50 absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black/5 focus:outline-hidden",
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  methods: {
    ...mapActions("auth", ["signout"]),
  },
};
</script>

<i18n src="./UserMenu.i18n.json"></i18n>
